const cols = [
  {
    title: 'Explore',
    items: [
      { label: 'Work', href: '#how-we-work' },
      { label: 'Capabilities', href: '#capabilities' },
      { label: 'Approach', href: '#approach' },
      { label: 'Insights', href: '#insights' },
    ],
  },
  {
    title: 'Company',
    items: [
      { label: 'About', href: '#about' },
      { label: 'Contact', href: '#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="relative w-full bg-background-100/80 pt-16 md:pt-24 pb-10 overflow-hidden border-t border-background-200">
      <div className="px-6 md:px-16 lg:px-28">
        {/* Brand */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <LinkBrand />
            <p className="mt-3 text-[14px] leading-[1.7] text-foreground-600 max-w-sm">
              Understanding complex public challenges, transforming intelligence
              into strategy, and turning strategy into measurable impact.
            </p>
          </div>
          <a
            href="#contact"
            className="inline-flex items-center gap-3 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-[15px] font-medium hover:bg-primary-600 transition cursor-pointer whitespace-nowrap"
          >
            Work With Us
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        {/* Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-[14px] text-foreground-600 pb-12 border-b border-background-200">
          {cols.map((col) => (
            <ul key={col.title} className="flex flex-col gap-3">
              <p className="text-[11px] tracking-[0.25em] uppercase text-foreground-400 font-mono mb-1">{col.title}</p>
              {col.items.map((it) => (
                <li key={it.label}>
                  <a href={it.href} className="cursor-pointer transition-colors hover:text-primary-700 whitespace-nowrap">
                    {it.label}
                  </a>
                </li>
              ))}
            </ul>
          ))}

          <div className="flex flex-col gap-3">
            <p className="text-[11px] tracking-[0.25em] uppercase text-foreground-400 font-mono mb-1">Office</p>
            <p className="leading-[1.7] text-[14px]">
              New Delhi, India
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <p className="text-[11px] tracking-[0.25em] uppercase text-foreground-400 font-mono mb-1">Contact</p>
            <a href="mailto:hello@prabhaw.in" className="hover:text-primary-700 cursor-pointer whitespace-nowrap transition-colors">
              hello@prabhaw.in
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-[12px] text-foreground-500">
            © {new Date().getFullYear()} Prabhaw. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-background-300 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition cursor-pointer">
              <i className="ri-linkedin-fill w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#hero" aria-label="X" className="w-9 h-9 rounded-full border border-background-300 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition cursor-pointer">
              <i className="ri-twitter-x-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#hero" aria-label="YouTube" className="w-9 h-9 rounded-full border border-background-300 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition cursor-pointer">
              <i className="ri-youtube-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function LinkBrand() {
  return (
    <a href="#hero" className="inline-flex items-center gap-3 cursor-pointer group" aria-label="Prabhaw">
      <span className="font-deva text-3xl leading-none text-foreground-950 group-hover:text-primary-700 transition-colors">प्रभाव</span>
      <span className="text-[10px] tracking-[0.3em] uppercase text-foreground-500 font-mono">Prabhaw</span>
    </a>
  );
}